/**
 * @desc 自动化流程引擎
 * @author caojianbo
 * @date 2024年04月08日09:33:51
 */
export default {
  流程名字: 'Process Name',
  请输入流程名字: 'Please enter process name',
  触发动作: 'Trigger Action',
  请选择: 'Please select',
  运行状态: 'Run Status',
  启用状态: 'Enabled Status',
  开启: 'Open',
  执行动作: 'Execute Action',
  输入LP主体名称: 'Enter LP subject name',
  请编辑流程名字: 'Please edit process name',
  请选择触发动作: 'Please select trigger action',
  请选择记录所在对象: 'Please select the object where the record is located',
  如果同时满足指定条件: 'If the specified conditions are met simultaneously',
  编辑流程引擎: 'Edit Process Engine',
  标题背景色: 'Title Background Color',
  标题: 'Title',
  '请填写标题(最多150个字符)': 'Please fill in the title (maximum 150 characters)',
  '请填写消息内容(最多3000个字符)': 'Please fill in the message content (maximum 3000 characters)',
  当: 'When',
  时: 'Time',
  就在: 'Just in',
  中: 'In',
  第: 'The',
  步: 'Step',
  命名: 'Naming',
  日志: 'Log',
  复制: 'Copy',
  删除: 'Delete',
  内容: 'Content',
  昨天: 'Yesterday',
  今天: 'Today',
  明天: 'Tomorrow',
  取消: 'Cancel',
  仅保存: 'Save Only',
  保存并启用: 'Save and Enable',
  然后执行另外: 'Then Execute Another',
  执行操作的时间: 'Execution Time of Operation',
  发送飞书消息: 'Send Feishu Message',
  流程名称: 'Process Name',
  自动化流程引擎: 'Automation Process Engine',
  流程名称不能超过100个字: 'The process name cannot exceed 100 characters',
  流程名称不能为空: 'Process name cannot be empty',
  删除当前步骤: 'Delete Current Step',
  '删除后，将无法回复该步骤，确认删除吗？': 'Once deleted, this step cannot be recovered. Are you sure you want to delete it?',
  自然时间: 'Natural Time',
  选择之前步骤产生的数据: 'Select data generated by previous steps',
  查找的记录: 'Records to be searched',
  新增的记录: 'Newly added records',
  修改的记录: 'Modified records',
  满足条件的记录: 'Records that meet the conditions',
  '当前页面尚未保存，是否确认关闭？': 'The current page has not been saved. Are you sure you want to close?',
  温馨提示: 'Friendly Reminder',
  确认关闭: 'Confirm Close',
  获取数据失败: 'Failed to retrieve data',
  自动化流程: 'Automation Process',
  个操作: 'Operation',
  请选择记录: 'Please Select Records',
  选择记录所在对象: 'Select Record Object',
  选择记录: 'Select Records',
  设置查找内容: 'Set Search Content',
  请选择要设置的查找内容: 'Please Select Search Content to Set',
  '新增与修改记录的内容满足条件时将会触发此条件，已有的记录内容满足条件时并不会触发': 'This condition will be triggered when the content of newly added or modified records meets the condition. It will not be triggered when existing record content meets the condition.',
  添加同时满足的条件: 'Add Conditions to Be Satisfied Simultaneously',
  就执行以下操作: 'Then Execute the Following Operations',
  向上插入一个操作: 'Insert an Operation Upwards',
  向下插入一个操作: 'Insert an Operation Downwards',
  复制操作: 'Copy Operation',
  删除操作: 'Delete Operation',
  全部记录: 'All Records',
  指定记录: 'Specified Records',
  当以下情况发生时: 'When the Following Conditions Occur',
  添加操作: 'Add Operation',
  新建流程引擎: 'Create Process Engine',
  添加底部按钮: 'Add Bottom Button',
  '添加后，可通过底部按钮跳转到指定链接或执行新增/修改记录': 'After adding, you can jump to the specified link or execute the add/modify records through the bottom button',
  默认样式: 'Default Style',
  强调样式: 'Emphasis Style',
  警示样式: 'Warning Style',
  跳转链接: 'Jump Link',
  按钮: 'Button',
  配置: 'Configuration',
  按钮文字: 'Button Text',
  按钮样式: 'Button Style',
  点击按钮时: 'When Clicking the Button',
  链接地址: 'Link Address',
  '必填,按钮上只展示25个字符': 'Required, only 25 characters are displayed on the button',
  请填写链接地址: 'Please fill in the link address',
  添加按钮: 'Add Button',
  '删除后，将无法恢复步骤，确认删除吗？': 'After deletion, the step cannot be recovered. Are you sure you want to delete it?',
  请选择群组: 'Please select a group',
  请添加接收人或群组: 'Please add recipients or groups',
  组织架构人员: 'Organizational Structure Personnel',
  租户群组: 'Tenant Group',
  输入关键字进行搜索: 'Enter keywords to search',
  第一步新增的记录: 'Records Added in the First Step',
  第一步满足条件的的记录: 'Records that Meet Conditions in the First Step',
  所有: 'All',
  任一: 'Any',
  设置筛选条件: 'Set Filtering Conditions',
  筛选该操作执行时符合条件的记录: 'Filter records that meet conditions when this operation is executed',
  符合以下: 'Meet the Following',
  筛选条件: 'Filtering Conditions',
  未查找到记录时: 'When No Records are Found',
  继续执行: 'Continue Execution',
  终止流程: 'Terminate Process',
  设置触发值: 'Set Trigger Value',
  第一步修改的的记录: 'Records Modified in the First Step',
  设置满足的条件: 'Set the conditions for satisfaction',
  关注以下任一字段变更: 'Watch for changes in any of the following fields',
  可输入字段名称进行搜索: 'You can enter field names to search',
  取消选择: 'Cancel Selection',
  修改记录后同时满足以下条件: 'Simultaneously meet the following conditions after modifying the record',
  新记录被添加时同时满足以下条件: 'Simultaneously meet the following conditions when a new record is added',
  级: 'Level',
  记录: 'Record',
  本人上级: 'Superior',
  本人: 'Self',
  运行耗时: 'Execution Time',
  运行日志: 'Execution Log',
  从以下步骤中选择: 'Select from the following steps',
  选择目标对象: 'Select the target object',
  请选择目标对象: 'Please select the target object',
  字段映射配置: 'Field mapping configuration',
  当此对象开启了飞书审批时: 'When the object has enabled the Feishu approval',
  新增记录: 'Add Record',
  记录内容变更: 'Record Content Changed',
  '新增/修改的记录满足条件': 'New/Modified Record Meets Conditions',
  定时触发: 'Scheduled Trigger',
  修改记录: 'Modify Record',
  AI生成内容: 'AI Generate Content',
  查找记录: 'Find Record',
  循环新增记录: 'Loop to Add Records',
  循环修改记录: 'Loop to Modify Records',
  依次处理每条记录: 'Process each record in sequence',
  循环方式: 'Loop Mode',
  需要循环处理的记录: 'Records needing loop processing',
  请选择循环方式: 'Please select loop mode',
  目标记录: 'Target Record',
  请选择目标记录: 'Please select target record',
  开启触发飞书审批: 'Enable triggering Feishu approval',
  直接发起审批: 'Initiate approval directly',
  无需发起审批: 'No need to initiate approval',
  ' 仅保存，完善后发起审批 ': 'Only save, initiate approval after completion',
  第1步新增的记录: 'Records added in Step 1',
  第1步满足条件的的记录: 'Records meeting the conditions in Step 1',
  第1步修改的的记录: 'Records modified in Step 1',
  日志产生时间: 'Log generation time',
  操作日志: 'Operation log',
  触发时间: 'Trigger time',
  操作人: 'Operator',
  执行结果: 'Execution result',
  请选择运行状态: 'Please select running status',
  请选择操作人: 'Please select operator',
  记录名称: 'Record name',
  执行详情: 'Execution details',
  操作时间: 'Operation time',
  变更为: 'Changed to',
  销售线索: 'Sales Lead',
  客户: 'Customer',
  商机: 'Business Opportunity',
  产品: 'Product',
  报价单: 'Quotation',
  '报价单-产品': 'Quotation-Product',
  合同: 'Contract',
  '合同-产品': 'Contract-Product',
  销售订单: 'Sales Order',
  '销售订单-产品': 'Sales Order-Product',
  售后服务单: 'After-sales Service Order',
  退货单: 'Return Order',
  '退货单-产品': 'Return Order-Product',
  '商机云文档/附件': 'Business Opportunity Cloud Document/Attachment',
  '商机-产品': 'Business Opportunity-Product',
  动态记录: 'Dynamic Record',
  线索池: 'Lead Pool',
  富文本: 'Rich text',
  子表单: 'Subform',
  秒级: 'Second level',
  毫秒级: 'Millisecond level',
  关联审批: 'Associated approval',
  单选: 'Single selection',
  多选: 'Multiple selection',
  映射至飞书审批: 'Map to Feishu approval',
  预置按钮: 'Preset button'
};
